import { useMemo, useCallback } from 'react'
import { useQuery } from '@apollo/client'

import {
  useStore as useFiltersStore,
  useActions as useFiltersActions,
} from 'components/contexts/event-page-filters'
import { SegmentedControl } from '~shared'
import { Item } from '~shared/Toggle'
import { TevoTicketsQuery } from 'gql'
import { useQueryParams } from '~hooks'
import { Placeholder } from '~ui'
import { filterTEvoTicketGroupsByKeywordsFilter } from 'components/contexts/event-page-filters/utils'
import { TEVO_TICKETS } from 'gql/artwork/queries'

export const VIP = 'vip'
export const TICKETS = 'tickets'

export const items: Array<Item> = [
  { label: 'Tickets', value: TICKETS },
  { label: 'VIP', value: VIP, icon: 'star-filled' },
]

const ToggleVipTickets = () => {
  const { setKeywords } = useFiltersActions()
  const { keywords } = useFiltersStore()
  const {
    query: { experienceId },
  } = useQueryParams()

  const { data, loading } = useQuery<TevoTicketsQuery>(TEVO_TICKETS, {
    variables: { artworkPk: experienceId, tevoTicketsLimit: 20 },
  })

  const displayToggle = useMemo(() => {
    if (data?.findArtwork?.tevoTicketGroups) {
      return !!filterTEvoTicketGroupsByKeywordsFilter(data?.findArtwork?.tevoTicketGroups, ['vip'])
        .length
    }

    return false
  }, [data])

  const value = useMemo(() => (keywords.includes('vip') ? VIP : TICKETS), [keywords])

  const onChange = useCallback(
    (v) => {
      if (v === VIP) {
        setKeywords([...keywords, VIP])
      } else {
        setKeywords(keywords.filter((kv) => kv !== VIP))
      }
    },
    [keywords, setKeywords]
  )

  if (loading) {
    return <Placeholder style={{ width: 180, minHeight: '45px', borderRadius: 8 }} />
  }

  if (displayToggle) {
    return <SegmentedControl value={value} onChange={onChange} items={items} />
  }

  return null
}

export default ToggleVipTickets
